import { render, staticRenderFns } from "./NewsroomItemEditorWrapper.vue?vue&type=template&id=84c7c62c&"
import script from "./NewsroomItemEditorWrapper.vue?vue&type=script&lang=js&"
export * from "./NewsroomItemEditorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c7c62c')) {
      api.createRecord('84c7c62c', component.options)
    } else {
      api.reload('84c7c62c', component.options)
    }
    module.hot.accept("./NewsroomItemEditorWrapper.vue?vue&type=template&id=84c7c62c&", function () {
      api.rerender('84c7c62c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Newsroom/Components/Editor/NewsroomItemEditorWrapper.vue"
export default component.exports